import { render } from "./AllMedications.vue?vue&type=template&id=187c28c6&scoped=true"
import script from "./AllMedications.vue?vue&type=script&lang=js"
export * from "./AllMedications.vue?vue&type=script&lang=js"

import "./AllMedications.vue?vue&type=style&index=0&id=187c28c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187c28c6"]])

export default __exports__